/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DataSource, Record } from '@fulcrumapp/fulcrum-core';
import { styled } from '@mui/material/styles';
import EditorTransition from './views/editor-transition';
import Modal from '../shared/modal';
import Editor from './editor';

interface Props {
  source: DataSource;
  addMode: boolean;
  editing: boolean;
  feature: Record;
  path: string;
  onSave: (record: Record) => void;
  onDelete: (record: Record) => void;
  onLinkedRecordSave: (record: Record) => void;
  onLinkedRecordDelete: (record: Record) => void;
  show: boolean,
  record: Record
  onClose: () => void;
  previewMode?: boolean;
  topBorder?: boolean;
  mapVisible?: boolean;
}

let StyledEditor = null;

const EditorModal: React.FC<Props> = ({
  show = true, topBorder = true, mapVisible, ...props
}) => {
  // @ts-ignore
  StyledEditor ??= styled(Editor)({
    position: 'fixed',
    top: 24,
    bottom: 24,
    left: 24,
    right: 24,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: 'transparent',
    boxShadow: '0 14px 45px rgba(0,0,0,0.25), 0 10px 18px rgba(0,0,0,0.22)',
  });

  return (
    <>
      { props.record && (
        <Modal
          show={show}
          // @ts-ignore
          transition={EditorTransition}
          style={{ zIndex: '650', position: 'absolute' }}
        >
          { /* @ts-ignore */ }
          <StyledEditor mapVisible={mapVisible} topBorder={topBorder} className="fs-exclude" {...props} />
        </Modal>
      )}
    </>
  );
};

export default EditorModal;
